import { GLOBAL_ITEMS } from 'consts/myItemsGroups';
import SaveTagButton from 'components/atoms/SaveTagButton/SaveTagButton';
import CardTagRegular from '../CardTagRegular/CardTagRegular';
import { SaveButtonContainer, Wrapper } from './CardTagGlobalSearch.style';

const LG_RULE = 14699;

const CardTagGlobalSearch = ({ tag }) => {
  return (
    <Wrapper>
      <SaveButtonContainer>
        <SaveTagButton tag={tag} buttonStyled={false} />
      </SaveButtonContainer>
      <CardTagRegular group={GLOBAL_ITEMS} tag={tag} isObjectFitContain={tag?.rule_id === LG_RULE} />
    </Wrapper>
  );
};

export default CardTagGlobalSearch;
